'use strict';
import * as $j_app$002epages$002e$002dApp$002dPage$002dInit$0024$002dLogout$002dError from "./app.pages.-App-Page-Init$-Logout-Error.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_pages_AppPageInit$LogoutError$SupabaseError(error) {
  this.Lapp_pages_AppPageInit$LogoutError$SupabaseError__f_error = null;
  this.Lapp_pages_AppPageInit$LogoutError$SupabaseError__f_error = error;
}
export { $c_Lapp_pages_AppPageInit$LogoutError$SupabaseError as $c_Lapp_pages_AppPageInit$LogoutError$SupabaseError };
$c_Lapp_pages_AppPageInit$LogoutError$SupabaseError.prototype = new $j_app$002epages$002e$002dApp$002dPage$002dInit$0024$002dLogout$002dError.$h_Lapp_pages_AppPageInit$LogoutError();
$c_Lapp_pages_AppPageInit$LogoutError$SupabaseError.prototype.constructor = $c_Lapp_pages_AppPageInit$LogoutError$SupabaseError;
/** @constructor */
function $h_Lapp_pages_AppPageInit$LogoutError$SupabaseError() {
}
export { $h_Lapp_pages_AppPageInit$LogoutError$SupabaseError as $h_Lapp_pages_AppPageInit$LogoutError$SupabaseError };
$h_Lapp_pages_AppPageInit$LogoutError$SupabaseError.prototype = $c_Lapp_pages_AppPageInit$LogoutError$SupabaseError.prototype;
$c_Lapp_pages_AppPageInit$LogoutError$SupabaseError.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1889702026, true);
});
$c_Lapp_pages_AppPageInit$LogoutError$SupabaseError.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_AppPageInit$LogoutError$SupabaseError)) {
    var x = this.Lapp_pages_AppPageInit$LogoutError$SupabaseError__f_error;
    var y = x$0.Lapp_pages_AppPageInit$LogoutError$SupabaseError__f_error;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lapp_pages_AppPageInit$LogoutError$SupabaseError.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_pages_AppPageInit$LogoutError$SupabaseError.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_pages_AppPageInit$LogoutError$SupabaseError.prototype.productPrefix__T = (function() {
  return "SupabaseError";
});
$c_Lapp_pages_AppPageInit$LogoutError$SupabaseError.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_pages_AppPageInit$LogoutError$SupabaseError__f_error;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_pages_AppPageInit$LogoutError$SupabaseError.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "error";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_pages_AppPageInit$LogoutError$SupabaseError.prototype.ordinal__I = (function() {
  return 1;
});
function $isArrayOf_Lapp_pages_AppPageInit$LogoutError$SupabaseError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_pages_AppPageInit$LogoutError$SupabaseError)));
}
export { $isArrayOf_Lapp_pages_AppPageInit$LogoutError$SupabaseError as $isArrayOf_Lapp_pages_AppPageInit$LogoutError$SupabaseError };
var $d_Lapp_pages_AppPageInit$LogoutError$SupabaseError = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_pages_AppPageInit$LogoutError$SupabaseError, "app.pages.AppPageInit$LogoutError$SupabaseError", ({
  Lapp_pages_AppPageInit$LogoutError$SupabaseError: 1,
  Lapp_pages_AppPageInit$LogoutError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lapp_pages_AppPageInit$LogoutError$SupabaseError as $d_Lapp_pages_AppPageInit$LogoutError$SupabaseError };
//# sourceMappingURL=app.pages.-App-Page-Init$-Logout-Error$-Supabase-Error.js.map
